// First we need to import axios.js
import axios from 'axios';
// Next we make an 'instance' of it
const instance = axios.create({
// .. where we make our configurations
//   baseURL: 'https://self-pre.nssf.or.tz/cfmsplus_api/web',
//   baseURL: 'https://ids.nssf.or.tz:461/cfmsplus_rest_api/web',
  baseURL: 'https://app.nssf.go.tz/index.php',
//   baseURL: 'http://10.10.47.33:90',
});

// Where you would set stuff like your 'Authorization' header, etc ...
// instance.defaults.headers.common['Authorization'] = 'AUTH TOKEN FROM INSTANCE';

// Also add/ configure interceptors && all the other cool stuff

export default instance;
